export const EMPTY_AMOUNT_PLACEHOLDER = '-';
export const GROUP_DATE_KEY_FORMAT = 'YYYY-MM-DD';
export const GROUP_DATE_FORMAT = 'D MMM';
export const PAYOUT_REQUEST_ID_PREFIX = '#';
export const REFERRAL_LINK_PROTOCOL = 'https://';
export const REFERRALS_PAGE_SIZE = 10;
export const SHARE_POPUP_FEATURES = 'noopener,noreferrer,width=600,height=640';
